import type { MacroPackageCaptureRequest, MacroPackageCaptureReply, PlaycastMessage, PlaycastMacroPackageCaptureMessages } from '../types';
import { formatMessage } from './_util/formatMessage';
import type { MacroPackageIngestResult } from '../types/api/macroPackage/publishParity';

export function request(hostId: string, message: MacroPackageCaptureRequest): PlaycastMessage<PlaycastMacroPackageCaptureMessages> {
  return formatMessage(hostId, 'host', { target: 'system', action: 'macroPackageCapture', isReply: false, message }) as PlaycastMessage<PlaycastMacroPackageCaptureMessages>;
}
export function native(hostId: string, message: MacroPackageCaptureRequest, localEditor: boolean): PlaycastMessage<PlaycastMacroPackageCaptureMessages> {
  return formatMessage(hostId, 'host', { target: 'record', action: 'packageInputs', isReply: false, message: { ...message, localEditor } }) as PlaycastMessage<PlaycastMacroPackageCaptureMessages>;
}

export function ingest(hostId: string, message: MacroPackageIngestResult): PlaycastMessage<PlaycastMacroPackageCaptureMessages> {
  return formatMessage(hostId, 'host', { target: 'system', action: 'macroPackageIngest', isReply: true, message }) as PlaycastMessage<PlaycastMacroPackageCaptureMessages>;
}

export function reply(hostId: string, message: MacroPackageCaptureReply): PlaycastMessage<PlaycastMacroPackageCaptureMessages> {
  return formatMessage(hostId, 'host', { target: 'system', action: 'macroPackageCapture', isReply: true, message }) as PlaycastMessage<PlaycastMacroPackageCaptureMessages>;
}
